import * as THREE from 'three'
import requestFrame from 'request-frame'

import { getRetinaRatio, getDeviceRatio, getBackingStoreRatio } from './utils'

import Text from './text'

global.THREE = THREE

class ArydioVisualiser {
  constructor({ el, context, props, settings }) {
    if (!el && !context) {
      console.log('el or context need to be supplied')
      return
    }
    this.el = el
    this.context = context

    this.loopID = null
    this.loop = this.loop.bind(this)
    this.addText = this.addText.bind(this)

    this.settings = Object.assign(
      {},
      {
        basePath: '/',
        customRenderControl: false,
      },
      settings
    )
    this.props = Object.assign({}, {}, props)

    this.count = 0
    this.size = { w: 0, h: 0 }

    // RENDERER
    this.renderer = new THREE.WebGLRenderer({
      context: this.context,
      antialias: true,
    })
    if (this.el) {
      this.el.appendChild(this.renderer.domElement)
    }

    // CAMERA
    this.camera = new THREE.PerspectiveCamera(45, 1, 1, 1000)
    this.camera.position.set(0, 0, 100)
    this.camera.lookAt(new THREE.Vector3())

    // SCENE
    this.scene = new THREE.Scene()

    // TEXT
    this.text = new Text()

    this.setNextLoop()

    this.text.loadFont(this.settings.basePath).then(this.addText)
  }

  addText({ mesh, geometry, texture }) {
    this.scaleText(mesh)

    const scale = 0.2

    mesh.rotation.set(Math.PI, 0, 0)
    mesh.position.set(
      (geometry.layout.width / 2) * scale * -1,
      (geometry.layout.height / 2) * scale * -1,
      0
    )
    mesh.scale.set(scale, scale, 1)

    this.text.update({
      u_resolution: new THREE.Vector2(this.size.w, this.size.h),
    })

    this.scene.add(mesh)
  }

  scaleText(mesh) {
    const { w, h } = this.size
    const aspect = w / h

    return
    if (mesh) {
      const zDistance = Math.abs(this.camera.position.z - mesh.position.z)
      const vFov = this.camera.fov * Math.PI * 180
      const scale = Math.pow(10, 9.5)
      const pH = 2 * Math.tan(vFov / 2) * zDistance * scale
      const pW = pH * aspect

      console.log(pW)

      mesh.scale.set(pW, pH, 1)
    }
  }

  updateSize({ width, height, ratio }) {
    const w = width
    const h = height
    const _ratio = ratio ? ratio : getDeviceRatio()

    this.size = { w, h }
    const aspect = w / h

    // UPDATE THREE SIZES
    this.scaleText(this.mesh)
    this.renderer.setSize(w, h)
    this.renderer.setPixelRatio(ratio)
    this.camera.aspect = aspect
    this.camera.updateProjectionMatrix()
  }

  loop() {
    this.count++

    const length = 500
    const playhead = (this.count % length) / length

    this.text.update({
      playhead,
    })
    //this.mesh.material.uniforms.playhead.value = (this.count % length) / length
    //this.mesh.material.uniforms.time.value = this.count

    this.renderer.render(this.scene, this.camera)

    this.setNextLoop()
  }

  setNextLoop() {
    if (this.settings.customRenderControl) {
      return null
    }

    const request = requestFrame('request')
    this.loopID = request(this.loop)
  }

  clearLoop() {
    if (this.loopID) {
      const cancel = requestFrame('cancel')
      cancel(this.loopID)
    }
  }

  remove() {
    this.clearLoop()

    if (this.el) {
      this.el.removeChild(this.renderer.domElement)
    }
    if (this.renderer) {
      this.renderer.dispose()
    }
  }
}

export default ArydioVisualiser
